import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { Commentable } from '@app/shared/models/comment';
import { BaseModel } from '@app/shared/models/base';
import { AuthenticationService } from '@app/core/authentication';

@Component({
    selector: 'editable-comments',
    templateUrl: './editable-comments.component.html',
    styleUrls: ['./editable-comments.component.scss']
})
export class EditableCommentsComponent<T extends BaseModel & Commentable> extends BaseComponent
                                                                             implements OnInit {

    @Input()
    public comments: T[];

    @Output()
    public create = new EventEmitter<string>();

    @Output()
    public update = new EventEmitter<T>();

    @Output()
    public remove = new EventEmitter<T>();

    public commentsInEditMode: Commentable[];

    public newComment: string;

    constructor(protected authenticationService: AuthenticationService) {
        super();
    }

    public ngOnInit() {
        this.commentsInEditMode = [];
    }

    public isEditable(comment: Commentable): boolean {
        return !this.disabled && !this.readonly && !!this.commentsInEditMode.find(comm => comm.identifier === comment.identifier);
    }

    public toggleEditMode(comment: Commentable): void {
        if (this.isEditable(comment)) {
            this.commentsInEditMode = this.commentsInEditMode.filter(comm => comm.identifier !== comment.identifier);
        } else {
            this.commentsInEditMode.push({
                identifier: comment.identifier,
                last_modification_date: comment.last_modification_date,
                comment: comment.comment,
                author: comment.author,
                author_id: comment.author_id
            });
        }
    }

    public cancelUpdate(comment: T): void {
        const original = this.commentsInEditMode.find(comm => comm.identifier === comment.identifier);

        if (original) {
            comment.comment = original.comment;
            comment.last_modification_date = original.last_modification_date;
        }

        this.toggleEditMode(comment);
    }

    public createComment(): void {
        this.create.emit(this.newComment);
        this.newComment = '';
    }

    public updateComment(comment: T): void {
        this.toggleEditMode(comment);
        this.update.emit(comment);
    }

    public deleteComment(comment: T): void {
        this.remove.emit(comment);
    }

    public isMyComment(comment: T): boolean {
        return this.authenticationService.currentUserValue.user.id === comment.author_id;
    }
}
